import React, { JSX } from 'react'
import './index.scss'

interface DownloadSidebarFormProps {
    formSubText: string
    formComponent: JSX.Element
}

const DownloadSidebarForm = (props: DownloadSidebarFormProps) => (
    <>
        <h2>Select download options</h2>
        <p className="large">{props.formSubText}</p>
        {props.formComponent}
    </>
)

export default DownloadSidebarForm
